<!--项目展示列表-->
<template>
  <div class="case-box">
    <div class="page-banner flex-column-c-c">
      <div class="banner-en">Group case</div>
      <div class="banner-title">集团案例</div>
      <div class="banner-line"></div>
    </div>
    <div class="case-main">
      <!--项目展示-->
      <div class="project-box">
        <div class="case-header">
          <div class="font70">ITEM</div>
          <div class="font50">项目展示</div>
        </div>
        <div class="project-main flex" v-for="(card,index) in preImgList" :key="index">
          <div class="main-swiper">
            <swiper :ref="`bigSwiper${index}`" class="swiper1" :options="swiperOption1">
              <swiper-slide v-for="(item,index) in card.picarr" :key="index">
                <div class="swiper-zoom-container">
                  <div class="img-wrap">
                    <img class="img-cover" :src="`${ajaxUrl}${item}`">
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <swiper ref="swiper2" class="swiper2" :options="swiperOption2" >
              <swiper-slide v-for="(item,ind) in card.picarr" :key="ind">
                <div class="swiper-zoom-container">
                  <div class="img-wrap">
                    <img :class="`bigSwiper${index}`" :src="`${ajaxUrl}${item}`">
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="main-intro flex-c-c">
            <div class="intro-info">
              <div class="info-title">{{card.title}}</div>
              <div class="info-p" v-html="card.description"></div>
              <router-link :to="`/caseDetail?id=${card.id}`" class="info-more flex-c-c">
                MORE
                <img src="../assets/news/more_arrow_right.png" alt="">
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <MessageFrom></MessageFrom>-->
    <Footer></Footer>
  </div>
</template>

<script>
  import MessageFrom from "../components/MessageFrom";
  import {ajaxPost,ajaxGet,ajaxUrl} from "../utils/ajax";
  import Footer from "../components/Footer";
  let vm = null
  export default {
    name: "Honour",
    data(){
      return {
        ajaxUrl,
        caseList:[],
        currentTab: 0,
        preImgList: [],
        otherCase: [],
        clickedIndex: 0,
        swiperOption1: {
          zoom: true,//双击放大
          observer: true,
          observeParents: true,
          grabCursor: true, // 抓手
        },
        swiperOption2: {
          slidesPerView: 4,
          spaceBetween: 11,
          grabCursor: true, // 抓手,
          slideToClickedSlide: true,
          watchSlidesVisibility: true, // 防止不可点击
          on: {
            //事件监听
            click: function (e) {
              vm.handleClickSlideEvent(this.clickedIndex,e);
            },
          },
        },
      }
    },
    components: {Footer, MessageFrom},
    updated() {

    },
    mounted() {
      this.fetchData('project','preImgList');
      vm = this;
    },
    methods: {
      fetchData(type,list){
        ajaxPost({
          url: 'ajaxCaseList',
          params:{
            type,
            limit: 999,
          },
          success(res){
            const { code,data,msg} = res;
            if(code === 200){
              this[list] = data;
            } else {
              this.$message.warning(msg);
            }
          }
        },this)
      },
      // 产品解决方案轮播 point点击事件
      handleClickSlideEvent(index,e) {
        console.log(e);
        //控制背景swiper跳转
        this.$refs[e.target._prevClass][0].$swiper.slideTo(index, 1000, true)
      },
    },
  }
</script>

<style scoped lang="scss">
  .case-box {
    width: 100%;
    .page-banner {
      width: 100%;height: 730px;background: url('../assets/case_banner.png') no-repeat center/cover;padding-top: 2%;position: relative;padding-bottom: 100px;
      .red-zz { position: absolute;width: 100%;height: 230px;background: linear-gradient(180deg,rgba($theme-color,.7),transparent);top: 0;left: 0;z-index: 2;}
      .banner-title { font-size: 60px;color: #fff;letter-spacing: 1px;line-height: 1.1;margin-top: -55px;}
      .banner-en { margin-top: 150px;font-size: 60px;color: #fff;letter-spacing: 1px;opacity: .1;text-transform: uppercase;}
      .banner-line { width: 110px;height: 3px;background: #fff;margin-top: 40px;}
    }
    .case-header { color: $theme-color;line-height: 1.3;padding: 0 12px;margin: 60px 0 70px 0;}
    .case-main {
      width: 100%;padding: 20px 110px;background: #fff;
      .honour-tab {
        margin-top: 10px;
        .tab-item {
          padding: 0 38px;height: 61px;background: #fff;color: $theme-color;margin-left: 28px;font-size: 16px;letter-spacing: 1px;cursor: pointer;
          &.active { background: $theme-color;color: #fff;}
        }
      }
    }
    .project-box {

      .project-main {
        width: 100%;height: 900px;margin-bottom: 100px;
        .main-swiper {
          flex:  0 0 77.8%;overflow: hidden;
          .swiper1 {
            height: 730px;
            .swiper-slide {
              background-color: #15243B;
            }
            .swiper-zoom-container{
              display: flex;
              flex-direction: column;
              align-items: center;
              .img-wrap{
                height: 730px;
                width: 100%;
              }
            }
          }
          .swiper2{
            height: 170px;
            .swiper-zoom-container{
              .img-wrap{
                height:100%;width:100%;
                img { width: 100%;height: 100%;display: block;object-fit: cover;}
              }
            }
            .swiper-slide-active{
              img{

              }
            }
          }
        }
        .main-intro {
          flex: 0 0 22.2%;background: #D6D6D6;color: $theme-color;padding: 20px 20px 20px 50px;
          .info-title {
            font-size: 30px;margin-bottom: 40px;position: relative;
            &:before {
              position: absolute;content: '';width: 114px;height: 8px;background: #9C463B;opacity: 0.3;left: 0;top: 30px;
            }
          }
          .info-p {font-size: 16px;line-height: 1.8;}
          .info-more {
            margin-top: 50px;width: 208px;height: 73px;background: $theme-color;color: #fff;font-size: 16px;
            img { margin-left: 24px;}
          }
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
    .case-box {
      .page-banner {
        height: 220px;padding: 0;
        .banner-en { margin-top: 50px;font-size: 30px;color: #fff;}
        .banner-title { font-size: 30px;margin-top: -30px;}
        .banner-line { width: 60px;height: 2px;margin-top: 14px;}
      }
      .case-main {
        padding: 20px 16px;
        >>> .flex-s-sb { display: block;}
        .case-header {
          padding: 0;margin: 10px 0;
          .font70 { font-size: 32px;word-spacing: -1px;}
          .font50 { font-size: 24px;}
        }
        .project-box {
          margin-bottom: 10px;
          .font20 { font-size: 16px;}
          .project-main {
            margin-top: 20px;height: auto;display: block;margin-bottom: 0;
            .swiper1 { height: 200px;}
            .swiper2 { display: none;}
            .main-intro {
              padding: 16px 14px;display: block;
              .intro-info {
                .info-title {
                  font-size: 18px;margin-bottom: 10px;
                  &:before { height: 5px;top: 15px;}
                }
                .info-p { font-size: 14px;max-height: 74px;overflow: hidden;}
                .info-more {
                  margin-top: 12px;font-size: 12px;width: 120px;height: 36px;
                  img { margin-left: 10px;width: 16px;}
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ItemList.vue